// Hook listy usług pozycji oferty –
// GET /sales-crm/clients/:cid/offers/:oid/positions/:pid/services

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export type OfferServicePriceType = 'UNIT' | 'TOTAL';

export interface ISalesCrmOfferService {
  id: number;
  offerVersionPositionId: number;
  serviceId: number | null;
  name: string;
  priceNet: number;
  priceGross: number | null;
  taxPercent: number;
  priceType: OfferServicePriceType;
  calcMethod: number | null;
}

export interface ISalesCrmOfferServicesResponse {
  page: number;
  total_count: number;
  total_pages: number;
  items: ISalesCrmOfferService[];
}

export const getSalesCrmOfferServicesQueryKey = (
  clientId: number,
  offerId: string,
  positionId: number
) =>
  [
    'sales-crm',
    'client',
    clientId,
    'offer',
    offerId,
    'position',
    positionId,
    'services'
  ] as const;

const getSalesCrmOfferServices = (
  clientId: number,
  offerId: string,
  positionId: number
): Promise<ISalesCrmOfferServicesResponse> =>
  axios.get(
    `/sales-crm/clients/${clientId}/offers/${offerId}/positions/${positionId}/services`
  );

export const useGetSalesCrmOfferServices = (
  clientId: number,
  offerId: string,
  positionId: number,
  options?: UseQueryOptions<ISalesCrmOfferServicesResponse, IError>
) =>
  useQuery<ISalesCrmOfferServicesResponse, IError>(
    getSalesCrmOfferServicesQueryKey(clientId, offerId, positionId),
    () => getSalesCrmOfferServices(clientId, offerId, positionId),
    {
      ...options,
      enabled:
        options?.enabled !== false &&
        clientId > 0 &&
        String(offerId).trim().length > 0 &&
        positionId > 0
    }
  );
